export const initialFactorValues = {
  type: null,
  name: '',
  description: '',
  kind: 'CONSTANT',
  form: 'PERCENTAGE',
  rate: null,
  rates: null,
  length_steps: [],
};
